import { FaDownload } from "react-icons/fa6";

function SquareCard({
  heading,
  icon,
  info,
  trail,
  percentage,
  handleOnClick,
  iconStyle,
  inlineInfo = false,
  infoClassName = "",
  breakdownRows = null,
  downloadIcon = false,
  downloadIconClickHandle = () => {},
}) {
  return (
    <div
      onClick={() => handleOnClick()}
      className="cursor-pointer relative md:w-56 md:h-44 rounded-2xl border border-greyishV2 border-opacity-50 flex flex-col justify-between bg-blackishV2 p-4"
    >
      {downloadIcon && (
        <button
          className="text-yellowish absolute top-2 right-2 text-xs"
          onClick={(e) => {
            e.stopPropagation();
            if (downloadIconClickHandle) downloadIconClickHandle();
          }}
        >
          <FaDownload />
        </button>
      )}
      <p className="text-sm text-greyish">{heading}</p>
      {inlineInfo ? (
        <>
          {Array.isArray(breakdownRows) && breakdownRows.length > 0 ? (
            <>
              <div className="flex items-start gap-3">
                <img className={`${iconStyle} object-contain`} src={icon} alt="" />
                <div className="flex-1 flex flex-col gap-1">
                  {breakdownRows.map((row) => (
                    <div key={row.label} className="flex items-center justify-between">
                      <span className="text-greyish text-xs">{row.label}</span>
                      <span className="text-yellowish text-xs font-semibold">
                        {row.count}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <p
                className={`mt-2 font-bold text-yellowish ${infoClassName || "text-2xl"}`}
              >
                {info}
              </p>
            </>
          ) : (
            <>
              <div className="flex items-center gap-3">
                <img className={`${iconStyle} object-contain`} src={icon} alt="" />
                <p
                  className={`font-bold text-yellowish ${infoClassName || "text-2xl"}`}
                >
                  {info}
                </p>
              </div>
              {trail ? <p className="text-greyish text-xs mt-1">{trail}</p> : null}
            </>
          )}
        </>
      ) : (
        <>
          <img className={`${iconStyle} object-contain`} src={icon} alt="" />
          <p className={`font-bold ${percentage ? "text-white" : "text-yellowish text-xl"}`}>
            {info} <span className="text-greyish text-sm">{trail}</span>
          </p>
        </>
      )}
      <p className="text-yellowish text-sm">{percentage}</p>
    </div>
  );
}

export default SquareCard;
